import {Exclude, Expose, Type} from 'class-transformer';
import {AbstractApiModel} from '../abstract.api.model';
import {ProjectApiModel} from '../project.api-model';
import {UserApiModel} from '../user.api-model';
import {ProjectCollaborationAssetApiModel} from './project-collaboration-asset.api-model';

@Exclude()
export class ProjectCollaborationApiModel extends AbstractApiModel {
  @Expose() public id: number;
  @Expose() public slug: string;
  @Type(() => ProjectApiModel)
  @Expose() public project: string | ProjectApiModel;
  @Type(() => UserApiModel)
  @Expose() public owner: string | UserApiModel;
  @Type(() => UserApiModel)
  @Expose() public collaborator: string | UserApiModel;
  @Expose() public type: string;
  @Expose() public impactType: string;
  @Expose() public status: string;
  @Expose() public title: string;
  @Expose() public shortDescription: string;
  @Expose() public description: string;
  @Expose() public serviceSummary: string;
  @Expose() public reviewNoteOwner: string;
  @Expose() public createHistoryEntryOnApproval: boolean;
  @Expose() public historyStartDate?: Date;
  @Expose() public historyEndDate?: Date;
  @Expose() public acceptedAssetsCount: number;
  @Expose() public pendingAssetsCount: number;
  @Expose() public rejectedAssetsCount: number;
  @Expose() public submittedAt: Date;
  @Expose() public acceptedAt: Date;
  @Expose() public rejectedAt: Date;
  @Expose() public archivedAt: Date;
  @Type(() => ProjectCollaborationAssetApiModel)
  @Expose() public coverAsset: string | ProjectCollaborationAssetApiModel;
  @Type(() => ProjectCollaborationAssetApiModel)
  @Expose() public assets: (string | ProjectCollaborationAssetApiModel)[] = [];
  @Expose() public historyPost: string | {'@id'?: string; id?: number};
  @Expose() public createdAt: Date;
  @Expose() public updatedAt: Date;
}
